<ngx-spinner bdColor="rgba(0, 0, 0, 0.4)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true">
  <p style="color: white"> Loading... </p>
</ngx-spinner>

<div class="modal-container background-color">
  <div class="modal-header">
    <h3 class="modal-title">{{ header }}</h3>

    <button mat-icon-button (click)="cancel()" class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>


  <form [formGroup]="incentiveForm" class="incentive-form" *ngIf="this.templates">

    <div class="section-input-dialog">
      <mat-form-field appearance="outline" class="input-dialog">
        <mat-label>Template</mat-label>
        <mat-select
          formControlName="templateId"
          (selectionChange)="onTemplateChange($event.value)">
          <mat-option *ngFor="let template of templates" [value]="template.templateId">
            {{ template.templateName }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="input-dialog">
        <mat-label>Contribution Period</mat-label>
        <input matInput [value]="selectedContributionPeriodName" readonly disabled="true" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="input-dialog">
        <mat-label>Effective Date</mat-label>
        <input
          matInput
          [matDatepicker]="picker"
          formControlName="effectiveDate"/>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>

    <!-- Threshold Table -->
    <div class="table-container mt-2" formArrayName="thresholds">
      <table mat-table [dataSource]="thresholdFormArray.controls">

        <!-- YTD Threshold Start -->
        <ng-container matColumnDef="min">
          <th mat-header-cell *matHeaderCellDef class="col-narrow mat-header-cell">
            Threshold Start
          </th>
          <td mat-cell *matCellDef="let group; let i = index" [formGroupName]="i" class="col-narrow">
            <input matInput formControlName="min" placeholder="Start" type="number" readonly />
          </td>
        </ng-container>

        <!-- YTD Threshold End -->
        <ng-container matColumnDef="max">
          <th mat-header-cell *matHeaderCellDef class="col-narrow mat-header-cell">
            Threshold End
          </th>
          <td mat-cell *matCellDef="let group; let i = index" [formGroupName]="i" class="col-narrow">
            <input matInput formControlName="max" placeholder="End" type="number" readonly />
          </td>
        </ng-container>

        <!-- Contract Rate -->
        <ng-container matColumnDef="contractRate">
          <th mat-header-cell *matHeaderCellDef class="col-narrow mat-header-cell">
            Contract Rate %
          </th>
          <td mat-cell *matCellDef="let group; let i = index" [formGroupName]="i" class="col-narrow">
            <input matInput formControlName="contractRate" placeholder="Contract Rate %" type="number" readonly />
          </td>
        </ng-container>

        <!-- Perm Rate -->
        <ng-container matColumnDef="permRate">
          <th mat-header-cell *matHeaderCellDef class="col-narrow mat-header-cell">
            Perm Rate %
          </th>
          <td mat-cell *matCellDef="let group; let i = index" [formGroupName]="i" class="col-narrow">
            <input matInput formControlName="permRate" placeholder="Perm Rate %" type="number" readonly />
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="thresholdDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: thresholdDisplayedColumns;"></tr>
      </table>
    </div>


    <!-- Footer -->
    <div class="mt-2 d-flex justify-content-between">
      <button mat-raised-button class="btn-cancel" type="button" (click)="cancel()">
        {{ isReadOnly ? 'Close' : 'Cancel' }}
      </button>

      <button
        mat-raised-button
        class="btn-action"
        type="button"
        (click)="submit()"
        *ngIf="!isReadOnly"
      >
        Submit for approval
      </button>
    </div>

  </form>
</div>
